import { useContext } from 'react'
import { createCtx, InitializableProviderProps } from '../../../context/_createCtx'
import { PatientFormContextValues } from '../Form/_props'

export const defaultPatientFormContextValues: PatientFormContextValues = {
    mode: 'CREATION',
    isExternal: false,
    isDisabled: false,
    patientId: undefined,
    ins: {
        storedData: undefined,
        isDmpConnectorAlive: false,
        isGettingConnector: false,
        isLoading: false,
        identityStatus: undefined,
        oidType: undefined,
    },
    isIdentityDowngraded: false,
    originalIdentityStatus: undefined,
    insiResultDialogOpen: false,
    loadingMessage: undefined,
    callType: undefined,
    loading: false,
}

const [ctx, provider] = createCtx(defaultPatientFormContextValues)

export const PatientFormContextProvider = ({
    children,
    initialValues,
}: InitializableProviderProps<PatientFormContextValues>) => provider({ children, initialValues })

export const usePatientFormContext = () => useContext(ctx)
